/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface JobBody
 */
export interface JobBody  {
    /**
     * 
     * @type {Date}
     * @memberof JobBody
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof JobBody
     */
    until?: Date;
}

/**
 * Check if a given object implements the JobBody interface.
 */
export function instanceOfJobBody(value: object): value is JobBody {
    return true;
}

export function JobBodyFromJSON(json: any): JobBody {
    return JobBodyFromJSONTyped(json, false);
}

export function JobBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobBody {
    if (json == null) {
        return json;
    }
    return {
        
                'from': json['from'] == null ? undefined : (new Date(json['from'])),
                'until': json['until'] == null ? undefined : (new Date(json['until'])),
    };
}

export function JobBodyToJSON(json: any): JobBody {
    return JobBodyToJSONTyped(json, false);
}

export function JobBodyToJSONTyped(value?: JobBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'from': value['from']?.toISOString().substring(0,10),
        'until': value['until']?.toISOString().substring(0,10),
    };
}


